import Keycloak from "keycloak-js";

declare global {
  interface Window {
    _kcInitRetry?: boolean;
  }
}

const keycloak = new Keycloak({
  url: "https://keycloak.development.almonds.ai",
  realm: "almondsai",
  clientId: "processcontrol",
});

let isKeycloakInitialized = false;

// Unified Keycloak initialization
const initKeycloak = () =>
  new Promise((resolve, reject) => {
    if (isKeycloakInitialized) {
      return resolve(keycloak);
    }

    keycloak
      .init({
        onLoad: "check-sso",
        checkLoginIframe: true,
        pkceMethod: "S256",
        silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
        enableLogging: true,
        flow: "standard",
        checkLoginIframeInterval: 30, // optional longer interval
      })
      .then((authenticated) => {
        if (!authenticated) {
          keycloak.login({ idpHint: "oidc" });
        } else {
          // Handle token refresh on expiry
          keycloak.onTokenExpired = () => {
            console.warn("Keycloak token expired — trying to refresh...");
            keycloak.updateToken(30).catch(() => {
              console.warn("Token refresh failed — redirecting to login...");
              keycloak.login({ idpHint: "oidc" });
            });
          };

          // Immediate refresh to prevent stale token/cookies
          keycloak.updateToken(5).catch(() => {
            console.warn("Immediate token refresh failed. Redirecting...");
            keycloak.login({ idpHint: "oidc" });
          });

          isKeycloakInitialized = true;
          resolve(keycloak);
        }
      })
      .catch((err) => {
        console.error("Keycloak init failed:", err);

        // Clear storage and retry ONCE
        if (!window._kcInitRetry) {
          console.warn("Retrying after clearing storage...");
          window._kcInitRetry = true;
          clearStorageAndReload();
        } else {
          console.error("Retry failed. Showing fallback UI or error.");
          reject(err);
        }
      });
  });

function clearStorageAndReload() {
  localStorage.clear();
  sessionStorage.clear();
  document.cookie.split(";").forEach((c) => {
    document.cookie = c
      .replace(/^ +/, "")
      .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
  });
  window.location.reload();
}

export { keycloak, initKeycloak };
